import { ReactNode, useRef } from 'react';
import { AccordionItemContent } from './AccordionItemContent';
import { useAccordionContext } from './context';
import { TId } from '@apia/util';
import { IAccordionItemButton } from './defaultElements/DefaultAccordionItemButton';

export interface IAccordionItemProps {
  /**
   * Cada elemento del acordeón tiene dos formas de renderizar el botón. O bien
   * se pasa un elemento AccordionItemButton como hijo o bien se pasan
   * buttonProps. En caso contrario, el elemento no tendrá botón.
   */
  buttonProps?: IAccordionItemButton;
  children?: ReactNode;
  defaultExpanded?: boolean;
  id: TId;
}

export const AccordionItem = ({
  children,
  id,
  defaultExpanded,
  ...props
}: IAccordionItemProps) => {
  const context = useAccordionContext();
  const Provider = context.hooks.useItemContextProvider(id);
  const hasRegistered = useRef(false);

  if (!hasRegistered.current) {
    hasRegistered.current = true;
    context.registerItem(id, {
      isChecked: false,
      isExpanded: !!defaultExpanded,
    });
  }

  return (
    <Provider>
      <AccordionItemContent id={id} {...props}>
        {children}
      </AccordionItemContent>
    </Provider>
  );
};
